
import React from 'react';
import LeagueHeaderItem from './header/LeagueHeaderItem';

interface LeagueHeaderProps {
  country?: string;
  league?: string;
  year?: string;
  stateName?: string;
}

const LeagueHeader: React.FC<LeagueHeaderProps> = ({ country, league, year, stateName }) => {
  console.log('LeagueHeader received props:', { country, league, year, stateName });
  
  const formatLeagueName = (leagueName: string | undefined) => {
    if (!leagueName) return '';
    
    // Remove any numeric prefix and trim whitespace
    const cleanedLeagueName = leagueName.replace(/^\d+\s+/, '');
    
    const leagueMap: { [key: string]: string } = {
      'E0': 'Premier League',
      'E1': 'Championship',
      'E2': 'League One',
      'E3': 'League Two',
      'EC': 'Conference',
      'SC0': 'Scottish Premiership',
      'SC1': 'Scottish Championship',
      'SC2': 'Scottish League One',
      'SC3': 'Scottish League Two',
      'D1': 'Bundesliga',
      'SP1': 'La Liga',
      'F1': 'Ligue 1',
      'I1': 'Serie A'
    };
    
    // If it's in the map, use that value, otherwise use the cleaned name
    return leagueMap[leagueName] || cleanedLeagueName;
  };

  const formatYear = (yearStr: string | undefined) => {
    if (!yearStr) return '';
    const year = parseInt(yearStr);
    if (isNaN(year)) return yearStr;
    return `${year}/${year + 1}`;
  };

  return (
    <div className="bg-transparent mb-4 w-full">
      <div className="flex flex-col sm:flex-row justify-end items-end sm:items-center gap-2 sm:gap-4 text-sm px-4">
        {stateName && <LeagueHeaderItem label="State" value={stateName} />}
        {country && <LeagueHeaderItem label="Country" value={country} />}
        {league && <LeagueHeaderItem label="League" value={formatLeagueName(league)} />}
        {year && <LeagueHeaderItem label="Season" value={formatYear(year)} />}
      </div>
    </div>
  );
};

export default LeagueHeader;
